import { MerchantId, SetHeaderService } from "@/helper/userHelper";
import { i18n } from "@/i18n";
import service from "../baseHttpService";
class PP30Service {
  InsertPP30Transaction(pp30Transaction: any) {
    const _input = {
      merchantId: MerchantId(),
      data: pp30Transaction,
    };
    return service.peakTaxAPI.post("/api/Transaction/InsertPP30Transaction", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
  GetPP30Transaction(transactionId: number) {
    const _input = {
      merchantId: MerchantId(),
      data: transactionId,
    };
    return service.peakTaxAPI.post("/api/Transaction/GetPP30Transaction", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
  UpdatePP30Transaction(pp30Transaction: any) {
    const _input = {
      merchantId: MerchantId(),
      data: pp30Transaction,
    };
    return service.peakTaxAPI.post("/api/Transaction/UpdatePP30Transaction", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
  VoidPP30Transaction(transactionId: number) {
    const _input = {
      merchantId: MerchantId(),
      data: transactionId,
    };
    return service.peakTaxAPI.post("/api/Transaction/VoidPP30Transaction", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
  GetTablePP30Transaction(input: any) {
    const _input = {
      merchantId: MerchantId(),
      data: input,
    };
    return service.peakTaxAPI
      .post("/api/Transaction/GetTablePP30Transaction", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
  GetTablePP30TransactionAdvanceSearchDefault(input: any) {
    const _input = {
      merchantId: MerchantId(),
      data: input,
    };
    return service.peakTaxAPI
      .post("/api/Transaction/GetTablePP30TransactionAdvanceSearchDefault", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
  GetTablePP30TransactionAdvanceSearch(input: any) {
    const _input = {
      merchantId: MerchantId(),
      data: input,
    };
    return service.peakTaxAPI
      .post("/api/Transaction/GetTablePP30TransactionAdvanceSearch", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
  GetTableCountPP30Transaction(input: any) {
    const _input = {
      merchantId: MerchantId(),
      data: input,
    };
    return service.peakTaxAPI
      .post("/api/Transaction/GetTableCountPP30Transaction", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
  GetTableCountPP30TransactionAdvanceSearch(input: any) {
    const _input = {
      merchantId: MerchantId(),
      data: input,
    };
    return service.peakTaxAPI
      .post("/api/Transaction/GetTableCountPP30TransactionAdvanceSearch", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
  GetTablePP30Form(input: any) {
    const _input = {
      merchantId: MerchantId(),
      data: input,
    };
    return service.peakTaxAPI.post("/api/Form/GetTablePP30Form", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
  GetPP30FormTableAdvanceSearch(input: any) {
    const _input = {
      merchantId: MerchantId(),
      data: input,
    };
    return service.peakTaxAPI
      .post("/api/Form/GetPP30FormTableAdvanceSearch", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
  GetPP30TransactionTableByPeriodTax(input: any) {
    const _input = {
      merchantId: MerchantId(),
      data: input,
    };
    return service.peakTaxAPI
      .post("/api/Form/GetPP30TransactionTableByPeriodTax", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
  GetPP30FormByPeriodTax(input: any) {
    const _input = {
      merchantId: MerchantId(),
      data: input,
    };
    return service.peakTaxAPI.post("/api/Form/GetPP30FormByPeriodTax", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
  GetPP30FormByLastDateTime() {
    const _input = {
      merchantId: MerchantId(),
      data: {},
    };
    return service.peakTaxAPI.post("/api/Form/GetPP30FormByLastDateTime", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
  DoFetchDataPP30Transaction(input: any) {
    const _input = {
      merchantId: MerchantId(),
      data: input,
    };
    return service.peakTaxAPI
      .post("/api/Transaction/FetchDataPP30Transaction", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
  InsertPP30Form(insertPP30FormModel: any) {
    const _input = {
      merchantId: MerchantId(),
      data: insertPP30FormModel,
    };
    return service.peakTaxAPI.post("/api/Form/InsertPP30Form", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
  GetPP30FormById(pp30FormId: any) {
    const _input = {
      merchantId: MerchantId(),
      data: pp30FormId,
    };
    return service.peakTaxAPI.post("/api/Form/GetPP30FormById", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
  GetPP30TransactionTableByPP30Id(pp30FormId: any) {
    const _input = {
      merchantId: MerchantId(),
      data: {
        pp30Id: pp30FormId,
      },
    };
    return service.peakTaxAPI
      .post("/api/Form/GetPP30TransactionTableByPP30Id", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
  UpdatePP30Form(updatePP30FormModel: any) {
    const _input = {
      merchantId: MerchantId(),
      data: updatePP30FormModel,
    };
    return service.peakTaxAPI.post("/api/Form/UpdatePP30Form", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
  VoidPP30Form(pp30FormId: any) {
    const _input = {
      merchantId: MerchantId(),
      data: pp30FormId,
    };
    return service.peakTaxAPI.post("/api/Form/VoidPP30Form", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
  GetFileStoragePP30Transaction(transactionId: number) {
    const _input = {
      merchantId: MerchantId(),
      data: transactionId,
    };
    return service.peakTaxAPI
      .post("/api/Transaction/GetFileStoragePP30Transaction", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
  AddFileStoragePP30Transaction(insertFilesStorage: any) {
    const requestBody: any = [];
    insertFilesStorage.forEach((file: any) => {
      requestBody.push({ merchantId: MerchantId(), data: file });
    });
    return Promise.all(
      requestBody.map((request: any) =>
        service.peakTaxAPI
          .post("/api/Transaction/AddFileStoragePP30Transaction", request, SetHeaderService())
          .then((res) => {
            return res;
          })
      )
    );
  }
  VoidFileStoragePP30Transaction(voidFileStorage: any) {
    const _input = {
      merchantId: MerchantId(),
      data: voidFileStorage,
    };
    return service.peakTaxAPI
      .post("/api/Transaction/VoidFileStoragePP30Transaction", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
  GetFileStoragePP30Form(pp30Id: number) {
    const _input = {
      merchantId: MerchantId(),
      data: pp30Id,
    };
    return service.peakTaxAPI.post("/api/Form/GetFileStoragePP30Form", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
  AddFileStoragePP30Form(insertFilesStorage: any) {
    const requestBody: any = [];
    insertFilesStorage.forEach((file: any) => {
      requestBody.push({ merchantId: MerchantId(), data: file });
    });
    return Promise.all(
      requestBody.map((request: any) =>
        service.peakTaxAPI.post("/api/Form/AddFileStoragePP30Form", request, SetHeaderService()).then((res) => {
          return res;
        })
      )
    );
  }
  VoidFileStoragePP30Form(voidFileStorage: any) {
    const _input = {
      merchantId: MerchantId(),
      data: voidFileStorage,
    };
    return service.peakTaxAPI.post("/api/Form/VoidFileStoragePP30Form", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
  GetIsFiledPP30Model(data: any) {
    const _input = {
      merchantId: MerchantId(),
      data: data,
    };
    return service.peakTaxAPI.post("/api/Form/GetFiledPP30ModelFromMongo", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
  UpdateIsFiledByPP30Id(data: any) {
    const _input = {
      merchantId: MerchantId(),
      data: data,
    };
    return service.peakTaxAPI.post("/api/Form/UpdateIsFiledByPP30Id", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
  UpdateIsPaidByPP30Id(data: any) {
    const _input = {
      merchantId: MerchantId(),
      data: data,
    };
    return service.peakTaxAPI.post("/api/Form/UpdateIsPaidByPP30Id", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
  UpdateIsClosingEntryPP30(input: any) {
    const _input = {
      merchantId: MerchantId(),
      data: {
        pp30Id: input.pp30Id,
        isClosingEntry: input.isClosingEntry,
        language: i18n.locale,
        journalDateTime: input.journalDate,
      },
    };
    return service.peakTaxAPI.post("/api/Form/UpdateIsClosingEntryPP30", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
  CreateExpenseByIsClosingEntryPP30(input: any) {
    const _input = {
      merchantId: MerchantId(),
      data: {
        payment: input.payment,
        language: i18n.locale,
        pp30Id: input.pp30Id,
        isClosingEntry: true,
      },
    };
    return service.peakTaxAPI
      .post("/api/Form/CreateExpenseByIsClosingEntryPP30", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
  GetClosingEntryPP30ModelFromMongo(input: any) {
    const _input = {
      merchantId: MerchantId(),
      data: {
        language: i18n.locale,
        pp30Id: input.pp30Id,
        isClosingEntry: false,
      },
    };
    return service.peakTaxAPI
      .post("/api/Form/GetClosingEntryPP30ModelFromMongo", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
  GetPeakTaxInvoiceList(idList: any) {
    const _input = {
      merchantId: MerchantId(),
      data: idList,
    };
    return service.peakTaxAPI.post("/api/Transaction/GetPeakTaxInvoiceList", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
  GetCommentLogPP30Transaction(transactionId: number) {
    const _input = {
      merchantId: MerchantId(),
      data: transactionId,
    };
    return service.peakTaxAPI
      .post("/api/Transaction/GetCommentLogPP30Transaction", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
  AddCommentLogPP30Transaction(data: any) {
    const _input = {
      merchantId: MerchantId(),
      data: data,
    };
    return service.peakTaxAPI
      .post("/api/Transaction/AddCommentLogPP30Transaction", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
  VoidCommentLogPP30Transaction(data: any) {
    const _input = {
      merchantId: MerchantId(),
      data: data,
    };
    return service.peakTaxAPI
      .post("/api/Transaction/VoidCommentLogPP30Transaction", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
  GetCommentLogPP30Form(pp30Id: number) {
    const _input = {
      merchantId: MerchantId(),
      data: pp30Id,
    };
    return service.peakTaxAPI.post("/api/Form/GetCommentLogPP30Form", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
  AddCommentLogPP30Form(data: any) {
    const _input = {
      merchantId: MerchantId(),
      data: data,
    };
    return service.peakTaxAPI.post("/api/Form/AddCommentLogPP30Form", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
  VoidCommentLogPP30Form(data: any) {
    const _input = {
      merchantId: MerchantId(),
      data: data,
    };
    return service.peakTaxAPI.post("/api/Form/VoidCommentLogPP30Form", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
  VoidIsClosingEntryPP30Expense(input: any) {
    const _input = {
      merchantId: MerchantId(),
      data: input,
    };
    return service.peakTaxAPI
      .post("/api/Form/VoidIsClosingEntryPP30Expense", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
  VoidIsClosingEntryPP30Journal(input: any) {
    const _input = {
      merchantId: MerchantId(),
      data: input,
    };
    return service.peakTaxAPI
      .post("/api/Form/VoidIsClosingEntryPP30Journal", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
}

export default new PP30Service();
